import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'owFooter', es);
i18next.addResourceBundle('en', 'owFooter', en);
i18next.addResourceBundle('pt', 'owFooter', pt);